import { useTranslation } from "react-i18next";
import { ConfirmModal } from "./ConfirmModal";

export function RegisterOptOutModal() {
    const { t } = useTranslation();

    const contentProps = {
        title: t('searchCard.modals.optOut'),
        description: t('feedback.confirm.optOut')
    }

    return <ConfirmModal {...contentProps}/>


}
